import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchSettings } from "../../api/api";
import { fetchSettingsSuccess, fetchSettingsFailure } from "./settings";

export function* handleFetchSettings(): SagaIterator {
  try {
    const data = yield call(fetchSettings);
    yield put(fetchSettingsSuccess(data));
  } catch (error) {
    console.error('VPO Settings Saga Ошибка:', error);
    yield put(fetchSettingsFailure((error as Error).message));
  }
}
